import * as React from 'react';
import AuthContext from '../AuthContext.js';
import { isAuthenticated } from '../utils/utils.js';

/**
 *
 */
function useAuthHeader() {
    var c = React.useContext(AuthContext);
    if (c === null) {
        throw new Error('Auth Provider is missing. ' +
            'Please add the AuthProvider before Router');
    }
    return function () {
        if (c.authState.auth && isAuthenticated(c.authState)) {
            return "".concat(c.authState.auth.type, " ").concat(c.authState.auth.token);
        }
        else {
            return "";
        }
    };
}

export { useAuthHeader as default };
